import Swal from 'sweetalert2';

export const SweetAlert = (props) => Swal.fire({
  title: props.title,
  text: props.text,
  heightAuto: false,
  customClass: {
    // container: 'toast-container',
    popup: 'sweet-alert-container',
    header: 'sweet-alert-header',
    title: 'sweet-alert-title',
    // closeButton: 'close-button-class',
    // icon: 'icon-class',
    // image: 'image-class',
    content: 'sweet-alert-content',
    // input: 'input-class',
    // actions: 'actions-class',
    // confirmButton: 'confirm-button-class',
    // cancelButton: 'cancel-button-class',
    // footer: 'footer-class'
  },
  ...props
})

export const Toast = (props) => Swal.mixin({
  toast: true,
  position: 'bottom',
  showConfirmButton: false,
  timer: props.timer,
  customClass: {
    // container: 'toast-container',
    popup: 'toast-container',
    // header: 'header-class',
    // title: 'title-class',
    // closeButton: 'close-button-class',
    // icon: 'icon-class',
    // image: 'image-class',
    content: 'toast-content',
    // input: 'input-class',
    // actions: 'actions-class',
    // confirmButton: 'confirm-button-class',
    // cancelButton: 'cancel-button-class',
    // footer: 'footer-class'
  },
  showClass: {
    popup: 'fadeInUp animated',
    backdrop: ''
  },
  hideClass: {
      popup: 'fadeOutUp animated',
      backdrop: ''
  },
  ...props
})